export default __webpack_public_path__ + "static/media/2nd.3.a407a5b4.jpg";